import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Switch,} from "react-router-dom";
import LeadForm from './components/LeadForm';
import SuccessPage from './components/SuccessPage';
import PageNotFound from './components/common/PageNotFound';
import SvgComponent from './components/common/SvgComponent';
import UpgradesError from "./components/UpgradesError";
import './style/font-family.css';
import './style/breadCrumb.css';
import './style/common-style.css';
import './style/leads-form.css';
import $ from 'jquery';
import './utagUtil';

class App extends Component {

    componentDidMount() {
        $(".headerWrapper").load(process.env.REACT_APP_VB_WEB_ASSETS+'header.html');
        $(".footerWrapper").load(process.env.REACT_APP_VB_WEB_ASSETS+'footer.html');
    }

    render() {
        return (
            <div className="App">
                <div className={"headerWrapper"}></div>
                <Router basename={process.env.REACT_APP_BASE}>
                    <Switch>
                        <Route path="/" exact component={LeadForm}/>
                        <Route path="/success/:type/:requestType/:reference/:model/:deviceId/:dealId" component={SuccessPage}/>
                        <Route path="/success/:type/:requestType/:reference/:model" component={SuccessPage}/>
                        <Route path="/success/:type" component={SuccessPage}/>
                        <Route path="/error" component={UpgradesError}/>
                        <Route><PageNotFound/></Route>
                    </Switch>
                    <SvgComponent/>
                </Router>
                <div className={"footerWrapper"}></div>
            </div>
        );
    }
}

export default App;
